import { render, staticRenderFns } from "./menu_v4.vue?vue&type=template&id=62720bc8&scoped=true"
import script from "./menu_v4.vue?vue&type=script&lang=js"
export * from "./menu_v4.vue?vue&type=script&lang=js"
import style0 from "./menu_v4.vue?vue&type=style&index=0&id=62720bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62720bc8",
  null
  
)

export default component.exports